import axios from './interceptor';

// The date filter is held as a Date object in Redux (so the picker can render
// it). Serialise it to an ISO yyyy-mm-dd string for the query, without pulling
// in moment at the service layer.
function formatDateParam(date) {
  if (!date) return undefined
  if (typeof date === 'string') return date
  const pad = (n) => (n < 10 ? '0' + n : '' + n)
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const WalletService = {

  // Campaign-level configuration for the voucher/wallet feature.
  // Returns options like the digital-card warning message.
  getWalletConfig({ clientSlug, campaignSlug }) {
    const url = `/api/clients/${clientSlug}/campaigns/${campaignSlug}/voucher/campaign_options`
    return axios({
      method: 'get',
      url: url
    });
  },

  // User-level voucher categories — used as the pill/filter options.
  // `archive` can be passed to restrict which categories are returned (e.g.
  // `false` means only categories that have non-archived vouchers).
  getWalletPills({ archive } = {}) {
    return axios({
      method: 'get',
      url: '/api/users/vouchers/categories',
      params: {
        archive: archive !== undefined ? archive : undefined
      }
    });
  },


  //   category_id — category pill filter (from filters.type)
  //   archive     — false shows only non-archived; omit to show all
  //   page        — pagination
  // Search and date are sent as-is; the backend may or may not support them.
  getWalletItems({ filters, page }) {
    const safeFilters = filters || {}
    // toggle=true means archived only → archive=true; toggle=false → no filter
    const archiveParam = safeFilters.toggle ? true : undefined
    return axios({
      method: 'get',
      url: '/api/users/vouchers',
      params: {
        category_id: safeFilters.type || undefined,
        archive: archiveParam,
        search: safeFilters.search || undefined,
        date: formatDateParam(safeFilters.date),
        page: page
      }
    });
  }
};
